import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { listModuleLenses } from 'root/src/client/logic/list/lenses'

const { viewAccordionOnExpand } = listModuleLenses

export default (state, { moduleId }) => viewAccordionOnExpand(moduleId, moduleDescriptions)
